import { useEffect } from 'react';
import { usePaywallStore } from './paywall.store';
import { usePaywallPlan, useIsOverMaxProjectCountLimit } from './paywall.hook';

/**
 * Syncs derived paywall state (plan, overLimit) into the paywall store.
 * Mount once (e.g. in Paywall dialog) so that useOpenPaywallDialog in list items
 * only reads from the store instead of subscribing to org + projects per item.
 */
export const PaywallDerivedSync = (): null => {
  const plan = usePaywallPlan();
  const overLimit = useIsOverMaxProjectCountLimit();
  const setDerived = usePaywallStore((s) => s.setDerived);

  useEffect(() => {
    setDerived({ plan, overLimit });
  }, [plan, overLimit, setDerived]);

  return null;
};
